import { ArrowRight, Flag, Palette, Trophy, Users } from "lucide-react";
import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

// Import individual achievement components
import CulturalDisplay from "./Cultural-Display";
import IndependentCelebration from "./Independence";
import InterStateChampionship from "./Inter-StateChampionship";
import StudentWeeks from "./StudentWeeks";

// Achievement data
const achievements = [
  {
    id: "independent-celebration",
    icon: Flag,
    title: "Independent Celebration",
    description:
      "Annual Independence celebration exchange events promoting understanding between Gambian and Indian cultures.",
    component: IndependentCelebration,
    iconColor: "text-blue-500",
  },
  {
    id: "student-weeks",
    icon: Users,
    title: "Student Weeks",
    description:
      "Engaging activities fostering student involvement and campus community spirit.",
    component: StudentWeeks,
    iconColor: "text-green-500",
  },
  {
    id: "inter-state-championship",
    icon: Trophy,
    title: "Inter-State Championship",
    description:
      "Competitive events showcasing excellence in various academic and sports disciplines.",
    component: InterStateChampionship,
    iconColor: "text-yellow-500",
  },
  {
    id: "cultural-display",
    icon: Palette,
    title: "Cultural Display",
    description:
      "Vibrant exhibitions highlighting diverse artistic expressions and heritage.",
    component: CulturalDisplay,
    iconColor: "text-purple-500",
  },
];

// Achievement card component
const AchievementCard = ({ achievement, onClick }) => (
  <div
    className="bg-white p-4 sm:p-6 rounded-sm hover:shadow-sm transition-shadow duration-300 cursor-pointer transform hover:scale-105"
    onClick={onClick}
  >
    <div className="flex justify-center mb-4">
      <achievement.icon className={`w-12 h-12 ${achievement.iconColor}`} />
    </div>
    <h3 className="text-xl font-semibold mb-2 text-center truncate">
      {achievement.title}
    </h3>
    <p className="text-gray-600 text-sm text-center line-clamp-3">
      {achievement.description}
    </p>
    <div className="flex justify-center mt-4">
      <ArrowRight className="w-6 h-6 text-blue-500 transition duration-300" />
    </div>
  </div>
);

// Achievement list component with responsive grid layout
const AchievementList = ({ onAchievementClick }) => (
  <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
      Our Achievements
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {achievements.map((achievement) => (
        <AchievementCard
          key={achievement.id}
          achievement={achievement}
          onClick={() => onAchievementClick(achievement.id)}
        />
      ))}
    </div>
  </div>
);

// Main component for achievements
const AchievementsMain = ({ basePath = "/achievement" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the route changes
  }, [location.pathname]);

  const handleAchievementClick = (id) => {
    navigate(`${basePath}/${id}`);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-12">
      <Routes>
        <Route
          path="/"
          element={
            <AchievementList onAchievementClick={handleAchievementClick} />
          }
        />
        {achievements.map((achievement) => (
          <Route
            key={achievement.id}
            path={`/${achievement.id}`}
            element={<achievement.component />}
          />
        ))}
      </Routes>
    </div>
  );
};

export default AchievementsMain;
